import { useFormContext } from '@calendly/form'
import { TimeClockCircleIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { colorTextSecondary } from '@calendly/ui/theme'
import { useSelector } from 'react-redux'

import { formatDurationValues } from 'components/event_type_edit'
import { isAvailableFeatureSelector } from 'features/billing'
import { formatDuration, formatDurationSummary } from 'services/event_types'

export const Summary = () => {
  const isMultipleDurationsAvailable = useSelector((state) => isAvailableFeatureSelector(state, { featureKey: 'multiple_durations' }))
  const { values } = useFormContext()
  const { duration, duration_options: durationOptions } = formatDurationValues(values)

  const durationSummary = isMultipleDurationsAvailable
    ? formatDurationSummary(duration, durationOptions, true)
    : formatDuration(duration, undefined, true)

  return (
    <BodyText color={colorTextSecondary}>
      <TimeClockCircleIcon size="standard" spacingRight="8" />
      {durationSummary}
    </BodyText>
  )
}
